import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class LogService {

    public info(message?: any, ...optionalParams: any[]) {
        // tslint:disable-next-line: no-console
        console.info(message, optionalParams);
    }

    public log(message?: any, ...optionalParams: any[]) {
        // tslint:disable-next-line: no-console
        console.log(message, optionalParams);
    }

    public error(message?: any, ...optionalParams: any[]) {
        // tslint:disable-next-line: no-console
        console.error(message, optionalParams);
    }
}
